import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { IIntegrationLogApi } from "./base";
import { IntegrationsLogFilterRequest } from "../models/request";
import { IntegrationsLogDataResponse, IntegrationsLogFileResponse } from "../models/response";
import { PaginationResponse } from "../models/common/paginationResponse";

const baseRoute: string = "IntegrationLog";

export class IntegrationLogApi extends IIntegrationLogApi {
	getSearchGrid(
		request: IntegrationsLogFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<IntegrationsLogDataResponse>>> {
		return api.get(`${baseRoute}`, { params: request, timeout: 300000 });
	}

	getFile(idFile: string, idSystemApplication: number): Promise<AxiosResponse<Result<IntegrationsLogFileResponse>>> {
		return api.get(`${baseRoute}/getfilelog`, {
			params: { idFile: idFile, idSystemApplication: idSystemApplication },
		});
	}
}
